// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"431":"e0343280","749":"e0343280"}[chunkId] + ".chunk.css";
};